import CONSTANTS from '@/constants'

export default [
  {
    path: '/workbooks',
    name: 'workbooks',
    component: () => import('@/components/navbar/Workbooks.vue'),
  },
]
